import { Pipe, PipeTransform } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { ContractStatus } from '../classes';
import { ContractService } from '../services/contract.service';

@Pipe({
  name: 'contractStatus'
})
export class ContractStatusPipe implements PipeTransform {

  constructor(private _contractService: ContractService){ }

  transform(statusId: number): Observable<string> {
    if(typeof statusId !== 'number') return of(null);
    return this._contractService.getContractStatusById(statusId, true).pipe(map((status: ContractStatus) => status.contractstatename));
  }

}
